import { Injectable } from '@angular/core';

@Injectable()
export class ApiService {
	constructor () {

	}

	public test(toPrint) {
		console.log("test works" + toPrint);
	}

}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/app/api.service.ts